import { Box, Flex, HStack, Spinner, Stack, Text } from '@chakra-ui/react';
import type { useCheckoutForm } from '../useCheckoutForm';
import { formatAmount } from './format';

type Controller = ReturnType<typeof useCheckoutForm>;

/** Choix du nombre d'échéances Alma + échéancier. */
export function AlmaPlans({ c }: { c: Controller }) {
  const { isLoadingPaymentPlans, isRefetchingPaymentPlans, updatedPaymentPlans, selectedPlan, handlePlanSelect } = c;
  const plans = (updatedPaymentPlans ?? []).filter((plan) => plan.installmentsCount > 1);
  const current = plans.find((plan) => plan.installmentsCount === selectedPlan);

  if (isLoadingPaymentPlans || isRefetchingPaymentPlans) {
    return (
      <HStack spacing={3} py={3}>
        <Spinner size="sm" />
        <Text className="cv2-hint">Chargement des échéanciers…</Text>
      </HStack>
    );
  }

  if (plans.length === 0) {
    return (
      <Text className="cv2-body" py={2}>
        Aucun échéancier disponible pour ce montant. Choisissez un autre moyen de paiement.
      </Text>
    );
  }

  return (
    <Stack spacing={4} mt={3} className="CheckoutV2AlmaPlans">
      <HStack spacing={2} flexWrap="wrap">
        {plans.map((plan) => (
          <button
            key={plan.installmentsCount}
            type="button"
            className={`cv2-plan${plan.installmentsCount === selectedPlan ? ' cv2-plan--active' : ''}`}
            onClick={() => handlePlanSelect(plan.installmentsCount)}
          >
            {plan.installmentsCount}×
          </button>
        ))}
      </HStack>

      {current && (
        <Box className="cv2-schedule">
          <Stack spacing={2}>
            {current.planDetails.map((detail, index) => (
              <Flex key={String(detail.dueDate)} justify="space-between" align="baseline">
                <Text className="cv2-eyebrow" style={{ letterSpacing: '0.06em' }}>
                  {index === 0 ? "Aujourd'hui" : new Date(String(detail.dueDate)).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}
                </Text>
                <Text className="cv2-strong cv2-num" fontSize="14px">
                  {formatAmount(Number(detail.totalAmount))}
                </Text>
              </Flex>
            ))}
          </Stack>
          <Flex justify="space-between" borderTopWidth="1px" borderColor="#e0e0e0" mt={3} pt={2.5}>
            <Text className="cv2-hint">Frais de paiement</Text>
            <Text className="cv2-strong" style={{ color: 'var(--cv2-accent)' }} fontSize="13px">
              Offerts
            </Text>
          </Flex>
        </Box>
      )}

      <Text className="cv2-small">Vous finaliserez le paiement sur l'interface sécurisée d'Alma, puis reviendrez automatiquement ici.</Text>
    </Stack>
  );
}
